// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Unified Video Player Styles */

/* Global body override for player page */
body:has(.video-player-page) {
    margin: 0;
    padding: 0;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
}

html:has(.video-player-page) {
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
}
.video-player-page {
    height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #000;
    color: white;
    overflow: hidden;
}

.video-player-page.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
}

.player-header {
    flex-shrink: 0;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 60px;
}

.player-header h1 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: white;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 60%;
}

.player-header .controls {
    display: flex;
    gap: 15px;
    align-items: center;
    flex-shrink: 0;
}

.player-header button {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.player-header button:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
}

.player-container {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 0; /* Important for flexbox */
}

.unified-video-player {
    width: 100%;
    height: 100%;
    background-color: #000;
    position: relative;
    border-radius: 0;
}

.unified-video-player video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.player-footer {
    flex-shrink: 0;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 15px 20px;
    min-height: 60px;
}

.player-footer .info-items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
}

.player-footer .info-item {
    display: flex;
    align-items: center;
    gap: 6px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
}

.player-loading-container,
.player-error-container {
    height: 100vh;
    max-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000;
    color: white;
    overflow: hidden;
}

.player-error-container {
    flex-direction: column;
    padding: 20px;
    text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
    .player-header {
        padding: 10px 15px;
        min-height: 50px;
    }
    
    .player-header h1 {
        font-size: 1.2rem;
        max-width: 50%;
    }
    
    .player-header .controls {
        gap: 10px;
    }
    
    .player-header button {
        padding: 6px 10px;
        font-size: 12px;
    }
    
    .player-header button span {
        display: none; /* Hide text on mobile, show only icons */
    }
    
    .player-footer {
        padding: 10px 15px;
        min-height: 50px;
    }
    
    .player-footer .info-items {
        gap: 10px;
        justify-content: space-around;
    }
    
    .player-footer .info-item {
        font-size: 12px;
        flex-direction: column;
        text-align: center;
        gap: 2px;
    }
}

@media (max-width: 480px) {
    .player-header h1 {
        font-size: 1rem;
        max-width: 40%;
    }
    
    .player-header button {
        padding: 4px 8px;
    }
    
    .player-footer .info-items {
        flex-direction: column;
        gap: 8px;
        align-items: center;
    }
    
    .player-footer .info-item {
        font-size: 11px;
    }
}

/* Landscape mode on mobile */
@media (max-width: 768px) and (orientation: landscape) {
    .player-header,
    .player-footer {
        display: none;
    }
    
    .player-container {
        height: 100vh;
    }
}

/* High DPI displays */
@media (min-resolution: 192dpi) {
    .player-header button {
        border-width: 0.5px;
    }
}

/* Dark theme adjustments */
@media (prefers-color-scheme: dark) {
    .video-player-page {
        background-color: #000;
    }
}

/* Focus states for accessibility */
.player-header button:focus,
.player-header button:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
}

/* Animation for fullscreen toggle */
.video-player-page {
    transition: all 0.3s ease;
}

.player-container {
    transition: height 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Player/UnifiedVideoPlayer.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC,yCAAyC;AACzC;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,2BAA2B;IAC3B,iDAAiD;IACjD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa,EAAE,0BAA0B;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,2BAA2B;IAC3B,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa,EAAE,yCAAyC;IAC5D;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,kBAAkB;QAClB,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,6BAA6B;AAC7B;IACI;;QAEI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA,mCAAmC;AACnC;;IAEI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":["/* Unified Video Player Styles */\n\n/* Global body override for player page */\nbody:has(.video-player-page) {\n    margin: 0;\n    padding: 0;\n    height: 100vh;\n    max-height: 100vh;\n    overflow: hidden;\n}\n\nhtml:has(.video-player-page) {\n    height: 100vh;\n    max-height: 100vh;\n    overflow: hidden;\n}\n.video-player-page {\n    height: 100vh;\n    max-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background-color: #000;\n    color: white;\n    overflow: hidden;\n}\n\n.video-player-page.fullscreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 9999;\n}\n\n.player-header {\n    flex-shrink: 0;\n    background: rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(10px);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    padding: 15px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 60px;\n}\n\n.player-header h1 {\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: white;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 60%;\n}\n\n.player-header .controls {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.player-header button {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    color: white;\n    padding: 8px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.player-header button:hover {\n    background: rgba(255, 255, 255, 0.2);\n    border-color: rgba(255, 255, 255, 0.3);\n    transform: translateY(-1px);\n}\n\n.player-container {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    min-height: 0; /* Important for flexbox */\n}\n\n.unified-video-player {\n    width: 100%;\n    height: 100%;\n    background-color: #000;\n    position: relative;\n    border-radius: 0;\n}\n\n.unified-video-player video {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.player-footer {\n    flex-shrink: 0;\n    background: rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(10px);\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    padding: 15px 20px;\n    min-height: 60px;\n}\n\n.player-footer .info-items {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 15px;\n}\n\n.player-footer .info-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    color: rgba(255, 255, 255, 0.8);\n    font-size: 14px;\n}\n\n.player-loading-container,\n.player-error-container {\n    height: 100vh;\n    max-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #000;\n    color: white;\n    overflow: hidden;\n}\n\n.player-error-container {\n    flex-direction: column;\n    padding: 20px;\n    text-align: center;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .player-header {\n        padding: 10px 15px;\n        min-height: 50px;\n    }\n    \n    .player-header h1 {\n        font-size: 1.2rem;\n        max-width: 50%;\n    }\n    \n    .player-header .controls {\n        gap: 10px;\n    }\n    \n    .player-header button {\n        padding: 6px 10px;\n        font-size: 12px;\n    }\n    \n    .player-header button span {\n        display: none; /* Hide text on mobile, show only icons */\n    }\n    \n    .player-footer {\n        padding: 10px 15px;\n        min-height: 50px;\n    }\n    \n    .player-footer .info-items {\n        gap: 10px;\n        justify-content: space-around;\n    }\n    \n    .player-footer .info-item {\n        font-size: 12px;\n        flex-direction: column;\n        text-align: center;\n        gap: 2px;\n    }\n}\n\n@media (max-width: 480px) {\n    .player-header h1 {\n        font-size: 1rem;\n        max-width: 40%;\n    }\n    \n    .player-header button {\n        padding: 4px 8px;\n    }\n    \n    .player-footer .info-items {\n        flex-direction: column;\n        gap: 8px;\n        align-items: center;\n    }\n    \n    .player-footer .info-item {\n        font-size: 11px;\n    }\n}\n\n/* Landscape mode on mobile */\n@media (max-width: 768px) and (orientation: landscape) {\n    .player-header,\n    .player-footer {\n        display: none;\n    }\n    \n    .player-container {\n        height: 100vh;\n    }\n}\n\n/* High DPI displays */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n    .player-header button {\n        border-width: 0.5px;\n    }\n}\n\n/* Dark theme adjustments */\n@media (prefers-color-scheme: dark) {\n    .video-player-page {\n        background-color: #000;\n    }\n}\n\n/* Focus states for accessibility */\n.player-header button:focus,\n.player-header button:focus-visible {\n    outline: 2px solid #fff;\n    outline-offset: 2px;\n}\n\n/* Animation for fullscreen toggle */\n.video-player-page {\n    transition: all 0.3s ease;\n}\n\n.player-container {\n    transition: height 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
